import { HomeownersTermsAgreement } from "@app/models/HomeownersTermsAgreement";
import { HomeownerApi } from "@app/services/apiServices/HomeownerApi";
import { LogoutService } from "@app/services/Logout.service";
import { NetworkErrorService } from "@app/services/NetworkError.service";
import { UserStore } from "@app/services/stores/UserStore";
import { take } from "rxjs/operators";
import { Inject, Injectable, NgZone } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { TermsDialog } from "@app/pages/registration/terms.dialog";

@Injectable()
export class LoginService {

    constructor(@Inject(HomeownerApi) public homeownerApi: HomeownerApi,
                @Inject(LogoutService) private logoutService: LogoutService,
                @Inject(UserStore) private userStore: UserStore,
                @Inject(NetworkErrorService) private networkErrorService: NetworkErrorService,
                @Inject(MatDialog) private matDialog: MatDialog,
                @Inject(NgZone) private ngZone: NgZone) {
    }

    login() {
        //use the hoahomeowner unless using an internal account, which we will then use the hard coded 7 id until internal is completely removed
        let homeownerId = this.userStore.getHoaHomeownerId();
        if (homeownerId && homeownerId !== 7) {
            this.validateTermsAndConditions(this.userStore.getHoaHomeownerId());
        }
    }

    private validateTermsAndConditions(homeownerId: number) {
        this.homeownerApi.homeownersIdToSUptodateGet(homeownerId).pipe(take(1)).subscribe({
            next: data => {
                if(data.valueOf() === true) {
                    console.info("T&C up to date")
                } else {
                    this.ngZone.run(() => {     //required for mobile app
                        let dialog = this.matDialog.open(TermsDialog, {
                            closeOnNavigation: false,
                            disableClose: true,
                            data: { updated: true }
                        });
                        dialog.afterClosed().pipe(take(1)).subscribe((value) => {
                            if (value === 'Y') {
                                console.info("updating T&C")
                                this.updateTermsAndConditions(homeownerId);
                            } else {
                                console.info("updating T&C declined, logging off")
                                this.logoutService.logout()
                            }
                        });
                    });
                }
            },
            error: (err) => {
                this.networkErrorService.handleNetworkError(err, true).pipe(take(1)).subscribe((shouldRetry) => {
                    if (shouldRetry === true) {
                        this.validateTermsAndConditions(homeownerId);
                    }
                });
            } });
    }

    private updateTermsAndConditions(homeownerId: number) {
        let today = new Date();
        let mm = ("0" + (today.getMonth() + 1)).slice(-2);
        let dd = ('0' + today.getDate()).slice(-2);
        let formattedDate = today.getFullYear() + "-" + mm + "-" + dd;

        const hoTermsAgreement: HomeownersTermsAgreement = {
            acceptedTermsDate: formattedDate,
            acceptedTerms: true,
            partyId: homeownerId
        }

        this.homeownerApi.homeownersTermsAgreementPost(false, hoTermsAgreement).pipe(take(1)).subscribe(() => {

        }, (err) => {
            this.networkErrorService.handleNetworkError(err, true).pipe(take(1)).subscribe((shouldRetry) => {
                if (shouldRetry === true) {
                    this.updateTermsAndConditions(homeownerId);
                }
            });

        });

    }

}

